const translations = {
  en: {
    greeting: "Hello",
    farewell: "Goodbye"
  },
  zh: {
    // Common
    'Edit': '修改',
    'Copy': '复制',
    'Name': '名称',
    'Ad Slot': '广告位',
    'Type': '类型',
    'Org': '组织',
    'Error': '错误',
    'Remark': '备注',
    'Detail': '详情',
    'Imps': '展示',
    'Clicks': '点击',
    'Active': '有效',
    'Running': '运行中',
    'All': '全部',
    'Reload': '刷新',
    'Cancel': '取消',
    'Confirm': '确认',
    'Column Settings': '列设置',
    'Reset Columns': '恢复默认',
    'Loading': '加载中',
    // NavBar
    'Job Groups': '订单列表',
    'Job List': '任务列表',
    'Daily Report': '数据报表',
    'Trackers Report': '后端数据',
    'Device Usage': '设备使用情况',
    'IPUA UV Count': '当日UV次数',
    'Jobs Changelist': '任务变更历史',
    'IP Count': '地域询量',
    'Settings': '基础设置',
    'Logout': '退出登录',
    // GroupList
    'Group ID': '订单ID',
    'Job ID': '任务ID',
    'Group Name': '订单名称',
    'Start/End Date': '开始/结束日期',
    'Traffic': '流量曲线',
    'Jobs': '任务数',
    'Total Imps': '总展示',
    'Total Clicks': '总点击',
    'Today Imps': '今日展示',
    'Today Clicks': '今日点击',
    'Today Actual Imps': '今日实际展示',
    'Today Actual Clicks': '今日实际点击',
    'Status': '状态',
    'Action': '操作',
    'Imp': '展示',
    'Click': '点击',
    'Mixed': '混合',
    'All Orgs': '全部组织',
    'Cleanup': '清理',
    'Cleanup Selected': '清理所选',
    'Pause Order': '暂停订单',
    'Resume Order': '继续订单',
    'Order Daily Report': '订单日报表',
    'Order Track Stats': '订单后端数据',
    'Order Schedule': '订单排期',
    'Order Jobs': '订单任务',
    'Custom Device Ids': '自定义设备号',
    'No Custom Device Ids': '没有自定义设备号',
    'Export Order Jobs': '导出订单任务',
    // JobList
    'Add Job': '新增任务',
    'Batch Add Jobs': '批量新增任务',
    'Batch Edit Jobs': '批量修改任务',
    'Batch Edit Today Dayparts': '批量修改当天时段',
    'Set Page Action': '设置页面行为',
    'Daypart': '时段',
    'Landing Url': '落地页代码',
    'Plan': '计划数',
    'Landing': 'Landing率',
    'Progress': '进度',
    'Delete Selected Jobs': '删除所选任务',
    'Pause Selected Jobs' : '暂停所选任务',
    'Resume Selected Jobs': '继续所选任务',
    'Export Selected Jobs': '导出所选任务',
    'Export Daily Report' : '导出日报表',
    'Export Hourly Report': '导出小时报表',
    'Export Region Report': '导出地域报表',
    'Export All Report'   : '导出所有报表',
    'Same Order Jobs'     : '相同订单任务',
    'Job Daily Report Popup': '日报表弹窗',
    'Job Daily Report'    : '日报表',
    'Track Stats'         : '后端数据',
    'Custom Monitor'      : '自定义监控',
    'Review Device Id'    : '设备号',
    'Device Id Usage'     : '设备使用情况',
    'Preset Dids'         : '预设设备号',
    'Check Another'       : '换一个',
    'No device found'     : '未获取到设备号',
    'Job Name'            : '任务名称',
    'Zip File'            : '压缩包文件',
    'All Devices'         : '全部设备',
    'iOS Percent'         : 'iOS比例',
    'Export last'         : '导出最近',
    'days'                : '天',
    // JobState component
    'Impressions': '展示',
    'Stay': '停留',
    'Adx Fill': 'Adx填充率',
    'Jump2': '二跳',
    'Jump3': '三跳',
    'Expect CTR': '目标CTR',
    'Target Jump2': '目标二跳',
    'Bounce Target': '目标跳出率',
    'Overrun': '溢出比例',
    'Landing Rate': 'Landing率',
    'Traffic Curve': '流量曲线',
    'Postback': '设备号回传',
    'Device Percent': '设备比例',
    'FreqCtrl ID': '频控ID',
    'Imp FreqCtrl': '展示频控',
    'Max FreqCtrl': '最大频控',
    'Average FreqCtrl': '平均频控',
    'UV Percent': 'UV比例',
    'OSV Percent': 'OSV比例',
    'Accept Cookies': '接受Cookies',
    'Page Actions': '页面行为',
    'Last Updated': '最后更新时间',
    'Imp Trackers': '展示代码',
    'Click Trackers': '点击代码',
    'Regions': '地域',
    'Extra Info': '其他信息',
    // FieldData
    'No job found': '找不到相关任务',
    'Max FreqCtrl 1': '最大频控一次',
    'Total Dids': '总设备ID数',
    'Used Dids': '已使用ID数',
    'Remaining Dids': '剩余ID数',
    'Used Dids Rate': 'ID使用率',
    'FreqCtrl Percent': '频控设置',
    'FreqCtrl Stats': '订单设备报表',
  },
};

export function t(key, locale='zh') {
  return translations[locale]?.[key] || key;
}
